/**
 * @description Exibe o conteúdo do drawer
 * @module DrawerContent
 * @since Agosto 2025
 */

import React from "react";
import {
  Box,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Stack,
  Typography,
} from "@mui/material";
import { useLoggedUserContext } from "@/contexts/LoggedUserContext";
import { useLocation, useNavigate } from "react-router-dom";
import { SectionSideBar } from "./SectionSideBar";
import { AutoStories, Quiz } from "@mui/icons-material";
import { useSessionContext } from "@/contexts/SessionContext";
import { currentFeatures } from "@/configs/Settings";

const SideBarMainContent: React.FC<{
  isMediumScreen: boolean;
}> = ({ isMediumScreen }) => {
  const { access } = useSessionContext();
  const { sideBarItens } = useLoggedUserContext();
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const suporteLink =
    access.type === "professional"
      ? "https://projectcore.atlassian.net/servicedesk/customer/portal/11"
      : "https://projectcore.atlassian.net/servicedesk/customer/portal/12";

  const manualLink =
    "https://projectcore.atlassian.net/wiki/spaces/FlowiseFluxmed/overview";

  return (
    <Box
      sx={{
        height: isMediumScreen ? "80vh" : "65vh",
        overflow: "auto",
        "&::-webkit-scrollbar": {
          width: "6px",
        },
        "&::-webkit-scrollbar-thumb": {
          backgroundColor: "primary700.main",
        },
      }}
    >
      <List>
        {sideBarItens
          ?.filter((item: any) => !item.parent)
          ?.map((item: any, index: number) => {
            const hasChildren = Boolean(
              sideBarItens?.some((child: any) => child.parent === item.text),
            );

            if (!hasChildren) {
              return (
                <ListItem key={`item-${index}`} disablePadding>
                  <ListItemButton
                    onClick={() => navigate(item.path)}
                    selected={item.path === pathname}
                    sx={{
                      p: 1,
                      borderRadius: "8px",
                    }}
                  >
                    {item.icon && (
                      <ListItemIcon>
                        {React.createElement(item.icon)}
                      </ListItemIcon>
                    )}
                    <ListItemText primary={item.text} />
                  </ListItemButton>
                </ListItem>
              );
            }
            return <SectionSideBar key={`section-${index}`} data={item} />;
          })}

        <>
          <ListItem disablePadding>
            <ListItemButton
              sx={{
                p: 1,
                borderRadius: "8px",
              }}
              onClick={() => window.open(manualLink, "_blank")}
            >
              <ListItemIcon>
                <AutoStories />
              </ListItemIcon>

              <ListItemText primary="Manual" />
            </ListItemButton>
          </ListItem>

          <ListItem disablePadding>
            <ListItemButton
              sx={{
                p: 1,
                borderRadius: "8px",
              }}
              onClick={() => window.open(suporteLink, "_blank")}
            >
              <ListItemIcon>
                <Quiz />
              </ListItemIcon>

              <ListItemText primary="Feedback e Suporte" />
            </ListItemButton>
          </ListItem>
        </>
      </List>
    </Box>
  );
};

export { SideBarMainContent };
